import { createContext, useContext } from 'react';

import IQueue from 'lib/common/types/InstanceQueue';
import TRedactedDirectory from 'lib/common/types/RedactedDirectory';

type InstanceContextType = {
  instanceQueues: IQueue[];
  allVisibleQueues: IQueue[];
  instanceDirectories: Record<string, TRedactedDirectory>;
};

const Context = createContext<InstanceContextType>({
  instanceQueues: [],
  allVisibleQueues: [],
  instanceDirectories: {},
});

// export the context hook
export const useInstanceContext = () => useContext(Context);

export default Context;
